import { CountingSchemes } from '@ahaslides-product/frontend-toolkit'
import sentry from '@/services/sentry'

const countingEntries = (presentationId, getters, { slide, perAnswerValue = true, histogram = false }, all = false) => {
  const base = { presentationId, slideId: slide.id, slideVersion: slide.version }
  const keys = []
  const groups = []
  if (all || getters.canReadAnswertextFromCounting) {
    keys.push(CountingSchemes.answerCountPerActivity(base))
    if (perAnswerValue && !histogram) groups.push(CountingSchemes.answerCountPerAnswerValue(base))
  }
  if (histogram && (all || getters.canReadAnswerscoreHistogramFromCounting)) {
    groups.push(CountingSchemes.answerCountPerAnswerValue(base))
  }
  return { keys, groups }
}

const wanted = (getters, { histogram }) => getters.canReadAnswertextFromCounting
  || (histogram && getters.canReadAnswerscoreHistogramFromCounting)

const SEED_RETRIES = 1

const report = (error) => sentry.captureException(error)

const reportTruncated = ({ path, count }) => report(
  new Error(`counting seed truncated at ${count} rows: ${path}`),
)

const countingActions = {
  subscribeCountingForSlideAction: ({ dispatch, getters, rootState }, payload) => {
    if (!payload?.slide?.id || !wanted(getters, payload)) return
    try {
      dispatch('counting/subscribe', {
        ...countingEntries(rootState.presentation.id, getters, payload),
        retries: SEED_RETRIES,
        onError: report,
        onTruncated: reportTruncated,
      }, { root: true }).catch(report)
    } catch (error) {
      report(error)
    }
  },

  unsubscribeCountingForSlideAction: ({ dispatch, getters, rootState }, payload) => {
    if (!payload?.slide?.id || !rootState?.presentation?.id) return
    try {
      dispatch('counting/unsubscribe', countingEntries(rootState.presentation.id, getters, payload, true), { root: true })
    } catch (error) {
      report(error)
    }
  },
}

export default countingActions
